import React, { useState, useEffect } from "react";
import { FaBookOpen, FaFileAlt, FaEye, FaDownload, FaCalendarAlt, FaStar } from "react-icons/fa";
import studentAxios from "../constants/studentAxios";

const Assignments = () => {
  const studentId = localStorage.getItem("studentId");
  const sessionId = localStorage.getItem("currentSessionId");

  const [student, setStudent] = useState(null);
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch student
  useEffect(() => {
    if (!studentId) return;
    const fetchStudent = async () => {
      try {
        const res = await studentAxios.get(`/students/getStudents/${studentId}`,
          { params: { sessionId } }
        );
        setStudent(res.data);
      } catch (err) {
        console.error("Error fetching student:", err);
      }
    };
    fetchStudent();
  }, [studentId]);

  // Fetch assignments
  useEffect(() => {
    if (!student || !sessionId) return;
    const fetchAssignments = async () => {
      try {
        const res = await studentAxios.get(
          `/assignments/getAssignmentsByClassNameAndSectionName/${encodeURIComponent(
            student.class
          )}/${encodeURIComponent(student.section)}`,
          { params: { sessionId } }
        );
        setAssignments(res.data);
      } catch (err) {
        console.error("Error fetching assignments:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchAssignments();
  }, [student, sessionId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen text-lg font-semibold">
        Loading…
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 md:p-6">
      {assignments.length === 0 ? (
        <div className="flex flex-col justify-center items-center bg-white shadow-md rounded-lg p-8 mt-10">
          <FaBookOpen className="text-gray-400 text-6xl mb-4 animate-bounce" />
          <p className="text-gray-600 text-lg">No assignments available.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {assignments.map((a) => (
            <div
              key={a._id}
              className="p-5 bg-white rounded-xl shadow-lg hover:shadow-2xl transition-transform transform hover:-translate-y-1 hover:scale-[1.02]"
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                  <FaFileAlt className="text-red-500 mr-2" />
                  {a.assignmentTitle}
                </h3>
                <span className="bg-yellow-100 text-yellow-800 text-xs font-semibold px-2 py-1 rounded-full">
                  Marks: {a.marks}
                </span>
              </div>

              <p className="text-gray-600 mb-1 flex items-center">
                <FaCalendarAlt className="mr-2 text-gray-400" />{" "}
                Due: {new Date(a.dueDate).toLocaleDateString()}
              </p>

              <p className="text-gray-600 mb-2">
                <strong>Subject:</strong> {a.subjectName}
              </p>

              <p className="text-gray-700 text-sm mb-3">{a.description}</p>

              {a.assignmentFile && (
                <div className="flex justify-between items-center mt-4 text-sm">
                  <a
                    href={a.assignmentFile}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline flex items-center gap-1"
                  >
                    <FaEye /> View
                  </a>

                  <a
                    href={`${process.env.REACT_APP_API_BASE_URL}/api/assignments/download/${a._id}`}
                    download
                    className="text-green-600 hover:underline flex items-center gap-1"
                  >
                    <FaDownload /> Download
                  </a>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Assignments;
